'use client';

import { NormalizedProduct } from '@ravago/shared/page-data/models/contentful-mapped';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableHeader } from '@ravago/shared/radiance/components/table/components/TableHeader/TableHeader';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { TableSubheader } from '@ravago/shared/radiance/components/table/components/TableSubheader/TableSubheader';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { IndustriesSegment } from '../../market-segment-list/components/industries-segment';

interface Props {
   products: NormalizedProduct[];
   totalColumns: number;
   locale: string;
   industryBaseRoute: string;
}

export const ProductCompareRelatedProperties = ({ products, totalColumns, locale, industryBaseRoute }: Props) => {
   const translate = useTranslations();

   return (
      <>
         <TableRow>
            <TableSubheader colSpan={totalColumns}>{translate('page-consumer.product-compare.table.related-properties')}</TableSubheader>
         </TableRow>
         <TableRow>
            <TableHeader>
               <Typography variant="body-highlight">{translate('page-consumer.product-compare.table.technologies')}</Typography>
            </TableHeader>
            {products.map((product) => (
               <TableCell verticalAlign="top" key={`technologies-${product.id}`}>
                  {product.technologies && product.technologies.length > 0 ? product.technologies.map((p) => p.name).join(' • ') : '-'}
               </TableCell>
            ))}
         </TableRow>
         <TableRow>
            <TableHeader>
               <Typography variant="body-highlight">{translate('page-consumer.product-compare.table.features')}</Typography>
            </TableHeader>
            {products.map((product) => (
               <TableCell verticalAlign="top" key={`features-${product.id}`}>
                  {product.features && product.features.length > 0 ? product.features.map((f) => f.name).join(' • ') : '-'}
               </TableCell>
            ))}
         </TableRow>
         <TableRow>
            <TableHeader>
               <Typography variant="body-highlight">{translate('page-consumer.product-compare.table.markets-and-segments')}</Typography>
            </TableHeader>
            {products.map((product) => (
               <TableCell verticalAlign="top" key={`markets-and-segments-${product.id}`}>
                  {product.marketSegments && product.marketSegments.length > 0 ? (
                     <IndustriesSegment segments={product.marketSegments} locale={locale} industryBaseRoute={industryBaseRoute} />
                  ) : (
                     '-'
                  )}
               </TableCell>
            ))}
         </TableRow>
      </>
   );
};
